export default "__VITE_ASSET__DwsH2uCT__"